

import { createContext } from 'react';

export const SchemaContext = createContext();
